import { all, call, fork, put, select, takeLatest } from "redux-saga/effects";
import AffiliatesActions, { AffiliatesTypes } from '../redux/Affiliates';
import AffiliationRequestsActions from "../redux/AffiliationRequests";
import MessageActions from "../redux/Messages";
import AuthActions from "../redux/Auth";
import UserActions from "../redux/User";
import {
  getAffiliatesRequest,
  addAffiliateRequest,
  deleteAffiliateRequest,
} from "../services/Affiliates";

import { deleteAffiliationRequestRequest } from "../services/AffiliationRequests";

function* getAffiliates() {
  try {
    yield put(AuthActions.showAuthLoader())
    const { user: { id } } = yield select(state => state.user);
    const affiliates = yield call(getAffiliatesRequest, id);
    yield put(AffiliatesActions.getAffiliatesDone(affiliates))
    yield put(AuthActions.hideAuthLoader())
  } catch (error) {

    yield put(AffiliatesActions.getAffiliatesError(error))
  }
}

function* addAffiliate({ userTargetId, affReqId }) {
  const { user: { id } } = yield select(state => state.user)
  yield put(AuthActions.showAuthLoader())
  yield call(addAffiliateRequest, userTargetId, id);
  yield call(deleteAffiliationRequestRequest, userTargetId, affReqId, id);
  yield put(AffiliationRequestsActions.getAffiliationRequests(id));
  yield put(MessageActions.showMessage('Orden creada con exito', false));
}

function* deleteAffiliate({ affilatesId, targetId }) {
  yield put(AuthActions.showAuthLoader());
  const { user: { id } } = yield select(state => state.user);
  yield call(deleteAffiliateRequest, affilatesId, targetId, id);
  yield put(AffiliatesActions.deleteAffiliateDone('Done'));
  yield put(AffiliatesActions.getAffiliates(id));
}

export function* getAffiliatesWatcher() {
  yield takeLatest(AffiliatesTypes.GET_AFFILIATES, getAffiliates);
}

export function* addAffiliateWatcher() {
  yield takeLatest(AffiliatesTypes.ADD_AFFILIATE, addAffiliate);
}

export function* deleteAffiliateWatcher() {
  yield takeLatest(AffiliatesTypes.DELETE_AFFILIATE, deleteAffiliate);
}

export default function* rootSaga() {
  yield all([
    fork(getAffiliatesWatcher),
    fork(addAffiliateWatcher),
    fork(deleteAffiliateWatcher),
  ]);
}